import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MatchPhotoUpload from '../Modals/MatchPhotoUpload';
import { PLAYER_PHOTO_WINDOW_MS } from '../../shared/utils/league-match-photo-visibility';

type Props = {
  event: LeagueFeed.Event;
  viewer?: Users.User;
  // eslint-disable-next-line no-unused-vars -- callback type signature
  onChange: (eventId: string, hasPhoto: boolean) => void;
};

/**
 * LG-63: maçın oyuncusu fotoğrafsız sonuç kartına onaydan sonraki 4 gün içinde fotoğraf ekler.
 * Rakipten isteme (LG-64) "Maçını anlat" satırında (FeedMatchStory).
 * Düğme yalnız süre içinde görünür; son karar sunucudadır (süre dolduysa yükleme bileşeni gizlenir).
 */
export default function FeedMatchPhotoAdd({ event, viewer, onChange }: Props) {
  const { t } = useTranslation('leagues');
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const { veri } = event;
  const participant = !!viewer?.id && [veri.kazanan?.id, veri.kaybeden?.id].includes(viewer.id);
  const inWindow = event.olusturma + PLAYER_PHOTO_WINDOW_MS > Date.now();
  if (!veri.mac_id || !participant || (!open && (veri.mac_foto_var_mi || !inWindow))) return null;
  return (
    <>
      <Button
        className="league-feed__photo-add"
        icon={<CameraOutlined aria-hidden="true" />}
        onClick={() => setOpen(true)}
      >
        {t('detail.feed.addPhoto')}
      </Button>
      <Modal
        title={t('detail.feed.addPhoto')}
        visible={open}
        onCancel={() => !busy && setOpen(false)}
        footer={null}
        destroyOnClose
      >
        <MatchPhotoUpload
          matchId={veri.mac_id}
          onBusyChange={setBusy}
          onChange={hasPhoto => onChange(event.id, hasPhoto)}
        />
      </Modal>
    </>
  );
}

FeedMatchPhotoAdd.defaultProps = { viewer: undefined };
